import { useLevMultiplier, useLpAPY, useFinalOusdApy, useTvl } from '@components/store/getters';
import CountUp from 'react-countup';
import { CardsWrapper, StyledCard, Value, Label } from './HomeCards.styles';
import { formatLongNumber } from '@components/eth/Utils';

export default function HomeCards() {
  const formatNumberWithCommas = (value: number) => {
    return formatLongNumber(value);
    // return value.toLocaleString();
  };
  const tvl = useTvl();
  const lpApy = useLpAPY();
  const ltApy = useFinalOusdApy();
  return (
    <CardsWrapper>
      <StyledCard>
        <Value>
          {!tvl && '--'}
          {tvl && (
            <>
              $<CountUp useEasing duration={3} end={tvl} formattingFn={formatNumberWithCommas} />
            </>
          )}
        </Value>
        <Label>Total Value Locked</Label>
      </StyledCard>
      <StyledCard>
        <Value>
          {!ltApy && '--'}
          {ltApy && (
            <>
              <CountUp useEasing duration={3} end={ltApy} formattingFn={formatNumberWithCommas} decimals={2} />%
            </>
          )}
        </Value>
        <Label>Leverage Taker APY</Label>
      </StyledCard>
      <StyledCard>
        <Value>
          {!lpApy && '--'}
          {lpApy && (
            <>
              <CountUp useEasing duration={3} end={lpApy} formattingFn={formatNumberWithCommas} decimals={2} />%
            </>
          )}
        </Value>
        <Label>Liquidity Provider APY</Label>
      </StyledCard>
    </CardsWrapper>
  );
}
